import he from 'he'
import Helpers from '../Helpers'

class ResultsHeader {
    constructor() {
        this.control = document.getElementsByClassName('results-lead')[0]
        if (typeof this.control !== 'undefined') {
            this.text = document.getElementsByClassName('results-lead__text')[0]
            this.h1 = this.text.getElementsByTagName('h1')[0]
            this.ferryAd = document.getElementsByClassName('results-lead__ferry-ad')[0]
            this.showmore = document.getElementsByClassName('results-list__loading')[0]
            this.readmoreWrapper = document.getElementsByClassName('results-end')[0]
            this.readMore = document.getElementsByClassName('read-more')[0]
            this.readMoreText = document.getElementsByClassName('results-end__text')[0]
            new Helpers(this.readMore).eventListener((e) => {
                this.readmoreListener(e)
            })
            if (this.control.getElementsByClassName('results-lead__video').length > 0) {
                this.video = this.control.getElementsByClassName('results-lead__video')[0]
            } else {
                // Video element not on the page as it has been disabled in config.
                // To preserve below code, simply create an element (not in the DOM) to obviate
                // need to modify code paths below.
                this.video = document.createElement('video')
            }
            this.initVideo()
        }
    }

    readmoreListener(e) {
        e.preventDefault();
        window.dataLayerQueue.push({ event: 'readMoreClick' });        
        if (this.readMoreText.hasAttribute('data-moved') && this.readMoreText.getAttribute('data-moved') === 'false') {
            const readMoreContent = this.readMoreText.innerHTML;
            this.removeReadMoreElements()
            const readMoreContainer = this.createReadMoreElement(readMoreContent)
            const showLessLinkTop = this.createShowLessElement()            
            const showLessLinkBottom = this.createShowLessElement()
            this.readMore.parentNode.insertBefore(showLessLinkTop, this.readMore.nextSibling);
            this.text.appendChild(readMoreContainer)
            showLessLinkBottom.style.marginBottom = '40px'
            this.text.appendChild(showLessLinkBottom);
            this.addShowLessEventListeners()
            this.readMoreText.setAttribute('data-moved', 'true')
        }
        if (this.text.querySelector('.results-header__read-more-text')) {
            this.showReadMoreSection()
        }
    }
    showReadMoreSection() {
        this.readMore.style.display = 'none'
        this.showShowLessLinks()
        this.text.querySelector('.results-header__read-more-text').style.display = 'block'
    }
    addShowLessEventListeners() {
        const showLessLinks = document.querySelectorAll('.show-less');
        showLessLinks.forEach((link) => {
            new Helpers(link).eventListener((e) => {
                e.preventDefault();
                this.showLess(e);
            });
        });
    }

    hideReadMoreText() {
        const readmoretextHeader = this.text.querySelector('.results-header__read-more-text')
        if (readmoretextHeader) {
            readmoretextHeader.style.display = 'none'
        }
    }
    showShowLessLinks() {
        const showLessLinks = this.text.querySelectorAll('.show-less');
        showLessLinks.forEach((link) => {
            link.style.display = 'inline-block';
        });
    }
    removeReadMoreElements() {
        const readmoretext = this.text.querySelector('.results-header__read-more-text');
        if (readmoretext) {
            readmoretext.remove();
        }
        const showLessElements = this.text.querySelectorAll('.show-less');
        showLessElements.forEach(element => element.remove());
    }
    createReadMoreElement(readMoreContent) {
        const readMoreContainer = document.createElement('div')
        readMoreContainer.classList.add('results-header__read-more-text')
        readMoreContainer.innerHTML = readMoreContent
        return readMoreContainer
    }
    createShowLessElement() {
        const showLessLink = document.createElement('a')
        showLessLink.href = '#'
        showLessLink.className = 'show-less'
        showLessLink.innerText = 'Show less'
        return showLessLink
    }
  
    showLess(e) {
        this.hideReadMoreText()
        this.text.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const showLessLinks = this.text.querySelectorAll('.show-less');
        showLessLinks.forEach((link) => {
            link.style.display = 'none';
        });
        this.readMore.style.display = 'inline-block'
    }

    hide() {
        if (typeof this.control !== 'undefined') {
            this.control.setAttribute('aria-hidden', 'true')
            this.text.setAttribute('aria-hidden', 'true')
            this.readmoreWrapper.setAttribute('aria-hidden', 'true')
            new Helpers(document.querySelector('body')).removeClass('results--has-header')
        }
    }

    update(xmlDoc) {
        if (typeof this.control !== 'undefined') {
            this.setImage(xmlDoc.getAttribute('image'))
            this.setVideo(xmlDoc.getAttribute('video'), xmlDoc.getAttribute('image'))
            this.setTitle(xmlDoc.getAttribute('title'))
            this.setIntro(xmlDoc.getAttribute('intro'))
            this.setReadMore(xmlDoc.getAttribute('readmore'))
            this.control.setAttribute('aria-hidden', 'false')
            this.text.setAttribute('aria-hidden', 'false')
            this.text.setAttribute('data-region', xmlDoc.getAttribute('regioncode'))
            new Helpers(document.querySelector('body')).addClass('results--has-header')
            this.readMore = document.getElementsByClassName('read-more')[0]
            this.readMoreText = document.getElementsByClassName('results-end__text')[0]
            this.backToTop = document.getElementsByClassName('back-to-top')[0]
            this.results = document.getElementById('search-results')
            new Helpers(this.readMore).eventListener((e) => {
                this.readmoreListener(e)
            })
            this.removeReadMoreElements()
        }
    }

    setReadMore(readmore) {
        const readmoreTextWrapper = this.readmoreWrapper.getElementsByClassName('results-end__text')[0]
        // clear current content
        readmoreTextWrapper.innerHTML = ''
        // parse escaped html content into temp element
        const temp = document.createElement('div')
        temp.innerHTML = he.decode(readmore)
        // load into page
        Array.from(temp.childNodes).forEach((node) => {
            readmoreTextWrapper.appendChild(node)
        })
        this.readMoreText.setAttribute('data-moved', 'false')
    }

    setImage(src) {
        const el = this.control.querySelector('.results-lead__image img')
        if (src != "" && el) {
            el.src = src
        }
    }

    showImage() {
        const el = this.control.querySelector('.results-lead__image img')
        if (el) {
            el.classList = "results-lead__image"
        }
    }

    hideImage() {
        const el = this.control.querySelector('.results-lead__image img')
        if (el) {
            el.classList = "results-lead__video--poster"
        }
    }

    setTitle(title) {
        this.text.getElementsByTagName('h1')[0].innerText = title
    }

    setIntro(intro) {
        // remove current content
        Array.from(this.text.childNodes).forEach((node) => {
            const tag = (typeof node.tagName === 'undefined') ? null : node.tagName
            // get rid of everything that isn't the heading or nested divs
            if (tag !== 'H1' && tag !== 'DIV' && tag !== 'A') {
                this.text.removeChild(node)
            }
        })
        // add in new content
        const temp = document.createElement('div')
        const beforeEl = this.h1.nextSibling
        temp.innerHTML = he.decode(intro)
        Array.from(temp.childNodes).forEach((node) => {
            this.text.insertBefore(node, beforeEl)
        })
    }

    setVideo(src, poster) {
        this.video.setAttribute('aria-hidden', src === '')
        this.video.setAttribute('poster', poster)
        this.video.setAttribute('src', src)
        if (src !== '' && this.videoVisible()) {
            this.video.load()
            this.video.play()
            this.hideImage()
        }
        else {
            this.showImage()
        }

    }

    videoVisible() {
        return this.video.offsetWidth > 0 && this.video.offsetHeight > 0
    }

    videoPlayable() {
        return this.videoVisible() && (this.video.paused === true || this.video.currentTime === 0)
    }

    initVideo() {
        // initial video play
        if (this.videoVisible()) {
            new Helpers(window).eventListener(() => {
                if (this.videoPlayable()) {
                    this.video.load()
                    this.video.play()
                }
            }, 'load')
        }
        // set up resize event to play video when its visible
        new Helpers(window).eventListener(() => {
            if (this.videoPlayable()) {
                this.video.load()
                this.video.play()
            }
        }, 'resize')
    }
}

export default ResultsHeader
